import { Ticket } from "../model/Ticket"
import { Equivalence } from "../model/Equivalence"

export class CalculationResult {
  carDistance: number
  vvsDistance: number
  carCO2Consumption: number
  vvsCO2Consumption: number
  carCost: number
  vvsCost: number
  co2Save: number
  costSave: number
  co2Equivalences: Equivalence[]
  costEquivalences: Equivalence[]
  state: CalculationState
  tickets: Ticket[]
  allTickets: Ticket[]
  individualDistanceMap: Map<String, number>
  isWalkingDistance: boolean
  constructor(
    carDistance: number,
    vvsDistance: number,
    carCO2Consumption: number,
    vvsCO2Consumption: number,
    carCost: number,
    vvsCost: number,
    co2Equivalences: Equivalence[],
    costEquivalences: Equivalence[],
    state: CalculationState,
    tickets: Ticket[],
    allTickets: Ticket[],
    individualDistanceMap: Map<String, number>,
    isWalkingDistance: boolean
  ) {
    this.carDistance = carDistance
    this.vvsDistance = vvsDistance
    this.carCO2Consumption = carCO2Consumption
    this.vvsCO2Consumption = vvsCO2Consumption
    this.carCost = carCost
    this.vvsCost = vvsCost
    this.co2Save = carCO2Consumption - vvsCO2Consumption
    this.costSave = carCost - vvsCost
    this.co2Equivalences = co2Equivalences
    this.costEquivalences = costEquivalences
    this.state = state
    this.tickets = tickets
    this.allTickets = allTickets
    this.individualDistanceMap = individualDistanceMap
    this.isWalkingDistance = isWalkingDistance
  }
}

export enum CalculationState {
  loading,
  done,
  error
}
